'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'IndustryRestService',
    function ($modal, IndustryRestService) {

        return {
            edit: edit,
            create: create,
            api: IndustryRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/industry-modal-create.html'),
                controller: 'IndustryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    industry: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/industry-modal-create.html'),
                controller: 'IndustryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    industry: function () {
                        return item;
                    }
                }
            });
        }

    }];